import type { Messages } from './messages.en';

export const fr: Messages = {
  'home.title': "L'Infiltré",
  'home.subtitle': 'Crise dans le quartier. Choisis un mode.',
  'home.resume.eyebrow': 'Reprendre',
  'home.resume.label': 'Continuer la partie sauvegardée',
  'home.standalone.eyebrow': 'Local',
  'home.standalone.label': 'Jouer sur cet appareil',
  'home.standalone.description': 'Fonctionne hors ligne. Un appareil, plusieurs joueurs.',
  'home.online.eyebrow': 'En ligne',
  'home.online.label': 'Salon privé',
  'home.online.description': 'Bientôt disponible.',
  'home.version': 'v0.0.0',
  'home.players_minutes': '3–12 joueurs · 5 min / manche',
  'home.eyebrow': 'Crise · Flics infiltrés',
  'home.lede':
    "Les Flics partagent un mot de passe. Un Infiltré en voit un autre, proche mais différent. Démasque-le avant qu'il ne te démasque.",
  'home.tagline.same_word': 'Même mot de passe. Presque.',
  'home.tagline.almost': "L'un de vous est infiltré.",
  'home.tagline.spot_the_imposter': "Démasque l'Infiltré.",
  'home.rules.cta': 'Règles du jeu',

  'rules.eyebrow': 'Briefing · 30 secondes',
  'rules.title': 'Règles du jeu',
  'rules.sub': 'Trois règles. Un Infiltré. Ne te fais pas griller.',
  'rules.step1.title': 'Chaque joueur reçoit un mot secret.',
  'rules.step1.body':
    "Les Flics partagent un mot de passe. L'Infiltré voit un mot proche — mais différent. Le Clochard ne voit rien : juste un SDF du quartier qui essaie de deviner.",
  'rules.step2.title': 'À tour de rôle, décris ton mot.',
  'rules.step2.body':
    "Un seul mot, pas de rime, pas d'épellation. Les Infiltrés doivent improviser sans se trahir.",
  'rules.step3.title': "Vote pour démasquer l'Infiltré.",
  'rules.step3.body':
    'Après les indices, la table vote. Si vous éliminez le Clochard, il a une dernière chance de deviner le mot des Flics et voler la victoire.',
  'rules.footer': 'Idéal entre 4 et 8 amis. Passe l’appareil. Fais confiance à personne.',
  'rules.got_it': "C'est noté",

  'setup.count.heading': 'Combien de joueurs ?',
  'setup.count.hint': 'Choisis le nombre, puis passe l’appareil',
  'setup.count.cta': 'Passer l’appareil au joueur 1',
  'setup.slot.player_label': 'Joueur {n}',
  'setup.slot.hint': 'Maintiens pour entrer ton nom',
  'setup.slot.welcome': 'Entre ton nom',
  'setup.slot.name_placeholder': 'Ton nom',
  'setup.slot.confirm': 'Confirmer — passer l’appareil',
  'setup.slot.duplicate_error': 'Ce nom est déjà pris.',

  'setup.players.heading': 'Joueurs',
  'setup.players.hint': "Entre chaque joueur. Le premier nom est l'hôte.",
  'setup.players.host_placeholder': "Nom de l'hôte",
  'setup.players.player_placeholder': 'Joueur {index}',
  'setup.players.add': '+ Ajouter un joueur',
  'setup.players.duplicate_error': 'Les noms doivent être uniques.',

  'setup.briefing.eyebrow': 'Préparation',
  'setup.briefing.title': 'Salle de briefing',
  'setup.briefing.settings': 'Réglages',
  'setup.host_settings.title': 'Paramètres de la salle',
  'setup.host_settings.eyebrow': 'Contrôles hôte · dossier',
  'setup.host_settings.hint': "Règle la manche avant de distribuer. Seul l'hôte voit ça.",
  'setup.host_settings.lock_in': 'Verrouiller',
  'setup.host_settings.section.mode': 'Mode de jeu',
  'setup.host_settings.section.roles': 'Rôles',
  'setup.host_settings.section.pace': 'Rythme',
  'setup.host_settings.section.word_pack': 'Pack de mots',
  'setup.host_settings.infiltre_hint': 'Voit un mot proche, doit bluffer',
  'setup.host_settings.clochard_label': 'Inclure un Clochard',
  'setup.host_settings.clochard_hint':
    'SDF du quartier. Ne sait rien. Peut voler la victoire en devinant le mot des Flics.',
  'setup.host_settings.timer_hint': 'Secondes par manche · 0 = sans minuteur',
  'setup.host_settings.timer_off': 'Off',
  'category.animals': 'Animaux',
  'category.food': 'Nourriture',
  'category.objects': 'Objets',
  'category.geography': 'Géographie',
  'category.nature': 'Nature',
  'category.sports': 'Sports',
  'category.movies': 'Films',
  'category.slang': 'Argot',
  'setup.briefing.headline_top': 'Salle de',
  'setup.briefing.headline_bottom': 'briefing.',
  'setup.briefing.lede':
    "Recrute tes suspects. Touche une polaroid pour renommer. Les mots sont scellés — même pour l'hôte.",
  'setup.briefing.recruit': 'Recruter',
  'setup.briefing.suspects': 'Suspects',
  'setup.briefing.need_more': 'Recrute encore {needed}',
  'setup.briefing.deal_cards': 'Lancer la manche',
  'setup.briefing.sealed_hint': 'Paire de mots scellée — personne ne la voit encore.',
  'setup.mugshot.customize_aria': 'Personnaliser le portrait',
  'setup.mugshot.title': 'Portrait-robot',
  'setup.mugshot.phase': 'Fiche 01',
  'setup.mugshot.subtitle': 'identité du suspect',
  'setup.mugshot.section.identity': 'Identité',
  'setup.mugshot.section.features': 'Signalement',
  'setup.mugshot.randomize': 'Aléatoire',
  'setup.mugshot.close': 'Fermer',
  'setup.mugshot.done': 'Terminé',
  'setup.mugshot.category.menton': 'Menton',
  'setup.mugshot.category.nez': 'Nez',
  'setup.mugshot.category.bouche': 'Bouche',
  'setup.mugshot.category.moustache': 'Moustache',
  'setup.mugshot.category.yeux': 'Yeux',
  'setup.mugshot.category.sourcils': 'Sourcils',
  'setup.mugshot.category.cheveux': 'Cheveux',
  'setup.mugshot.category.accessoire': 'Accessoire',
  'setup.recruit.sealed_eyebrow': 'Scellé · ne pas ouvrir',

  'setup.options.heading': 'Options',
  'setup.options.include_clochard': 'Inclure un Clochard',
  'setup.options.discussion_seconds': 'Minuteur de discussion',
  'setup.options.discussion_seconds_hint': 'Secondes avant le vote. 0 = manuel.',
  'setup.options.locale': 'Langue',

  'locale.en': 'English',
  'locale.fr': 'Français',
  'locale.es': 'Español',
  'locale.de': 'Deutsch',
  'locale.pt': 'Português',

  'setup.start': 'Lancer la partie',

  'play.no_active_game': 'Aucune partie en cours.',
  'play.go_home': "Retour à l'accueil",
  'play.connecting': 'Connexion…',
  'play.phase_label': 'Phase : {phase}',

  'play.privacy_gate.pass_to': 'Passer à',
  'play.privacy_gate.hold_to_reveal': 'Appuie et maintiens pour révéler',
  'play.privacy_gate.tap_to_reveal': 'Touche pour révéler',
  'play.privacy_gate.hold_to_see_word': 'Maintiens pour voir ton mot',
  'play.privacy_gate.tap_to_see_word': 'Touche pour voir ton mot',
  'play.privacy_gate.hold_to_vote': 'Maintiens pour voter',
  'play.privacy_gate.done': 'Terminé — passe l’appareil',
  'play.pass_device.eyebrow': 'Passer l’appareil à',
  'play.pass_device.dossier': 'Dossier · {n}/{total}',
  'play.pass_device.no_peeking': "— Pas de coup d'œil. Les murs ont des oreilles.",
  'play.pass_device.ready': 'Je suis prêt',

  'play.handoff.all_done_eyebrow': 'Tous les joueurs ont terminé',
  'play.handoff.all_revealed_title': 'Tous les joueurs sont prêts',
  'play.handoff.all_revealed_description': 'Place à la discussion. Parlez chacun à votre tour.',
  'play.handoff.continue': 'Continuer',
  'play.handoff.all_voted_title': 'Tous les votes sont enregistrés',
  'play.handoff.all_voted_description': 'Touche pour révéler.',
  'play.handoff.reveal': 'Révéler',

  'pause.button': 'Pause',
  'pause.eyebrow': 'Pause · entre nous',
  'pause.title': 'Souffle un coup.',
  'pause.sub': 'Reprends ou coupe court.',
  'pause.resume.label': 'Reprendre',
  'pause.resume.sub': 'Retour à la partie.',
  'pause.rules.label': 'Règles du jeu',
  'pause.rules.sub': 'Rafraîchis les règles.',
  'pause.quit.label': 'Quitter',
  'pause.quit.sub': 'Fin de partie. Préférences gardées.',
  'pause.recap.label': 'Récap du tour',
  'pause.recap.sub': 'Voir le dossier en cours.',

  'recap.eyebrow_between': 'Dossier · tour clos',
  'recap.eyebrow_end': 'Dossier · complet',
  'recap.title_between': 'Récap du tour',
  'recap.title_end': 'Tout le déroulé',
  'recap.sub_between': "Ce qui s'est passé. Profites-en, ou pas.",
  'recap.sub_end': 'Chaque tour, chaque élimination, dans l’ordre.',
  'recap.empty': 'Aucun tour joué — le dossier est vide.',
  'recap.still_in_room': 'Encore en jeu',
  'recap.eliminated_meta': 'Éliminé · {count} restants',
  'recap.round_short': 'T',
  'recap.close': 'Fermer',

  'round.your_role': 'Ton rôle',
  'round.your_card': 'Ta carte',
  'round.your_word': 'Ton mot',
  'round.no_word': 'Aucun mot',
  'round.no_word_hint': 'À vous de bluffer.',

  'round.speaking.heading': 'Ordre de parole',
  'round.speaking.hint': 'Chaque joueur donne un indice à son tour. Ne dis pas le mot directement.',
  'round.speaking.ready_to_vote': 'Prêts à voter',
  'round.speaking.order_eyebrow': 'DANS L’ORDRE',
  'round.speaking.order_title': 'Autour de la table',

  'round.vote.eyebrow': '{name} — ton vote',
  'round.vote.heading': "Épingle l'Infiltré",

  'round.result.eyebrow': 'Tour clos',
  'round.result.complete_eyebrow': 'Dossier',
  'round.result.voted_out_eyebrow': 'Éliminé',
  'play.clochard.spotlight': 'Sous les projecteurs',
  'play.clochard.last_words': '{name}, derniers mots.',
  'play.clochard.one_guess': 'Une chance',
  'round.result.cast_eyebrow': 'équipage révélé',
  'round.result.suspects_count': 'suspects',
  'round.result.win_team.flic': 'FLICS',
  'round.result.win_team.infiltre': 'INFILTRÉS',
  'round.result.win_team.clochard': 'CLOCHARD',
  'round.result.win_verb.flic': 'GAGNENT.',
  'round.result.win_verb.infiltre': 'GAGNENT.',
  'round.result.win_verb.clochard': 'GAGNE.',
  'round.result.sub_flic': "— la table l'a démasqué.",
  'round.result.sub_infiltre': '— caché en pleine lumière.',
  'round.result.sub_clochard': '— un coup. Du sang-froid pur.',
  'round.result.replay_cta': 'Rejouer',
  'round.result.new_dossier_cta': 'Nouveau dossier',
  'round.result.title': 'Résultat du tour',
  'round.result.title_finished': 'Partie terminée',
  'round.result.still_in': 'Encore en jeu',
  'round.eliminated': 'Éliminé',
  'round.winner': 'Vainqueur',
  'round.case_closed': 'Affaire classée',
  'round.flic_word': 'Mot des Flics',
  'round.infiltre_word': 'Mot des Infiltrés',
  'round.next_round': 'Tour suivant',
  'round.back_home': "Retour à l'accueil",
  'round.result.view_case_log_one': 'Voir le journal · 1 manche',
  'round.result.view_case_log_many': 'Voir le journal · {count} manches',
  'round.rematch': 'Revanche',
  'round.replay.button': 'Une autre manche',
  'round.replay.waiting': 'En attente ({count}/{needed} prêts)',
  'round.replay.requested': 'Tu veux continuer',
  'round.eliminate.heading': 'Qui est éliminé ?',
  'round.eliminate.eyebrow': 'Vote',
  'round.eliminate.host_hint': 'Hôte · pointe le perdant',
  'round.eliminate.subtitle': 'Vote à voix haute · à la table',
  'round.eliminate.body':
    'Chaque joueur vivant pointe quelqu’un, sans hésiter. Compte les mains autour de la table — l’hôte tape sur le perdant.',
  'round.eliminate.cta_idle': 'Touche un joueur',
  'round.eliminate.cta_picked': 'Éliminer {name}',
  'round.speaking.rule_eyebrow': 'Règle du tour',
  'round.speaking.rule_line1': 'Un mot.',
  'round.speaking.rule_line2': 'Pas de répétition.',
  'round.discuss.heading': 'Discussion',
  'round.discuss.eyebrow_calm': 'Parle · accuse · défends',
  'round.discuss.eyebrow_danger': 'Le temps presse',
  'round.discuss.seconds_label': 'Secondes',
  'round.discuss.tick_calm.0': '« Qui bluffe ? »',
  'round.discuss.tick_calm.1': "« Je n'y crois pas. »",
  'round.discuss.tick_calm.2': '« Prouve-le. »',
  'round.discuss.tick_calm.3': "« Toi d'abord. »",
  'round.discuss.tick_hot.0': '« Le temps file. »',
  'round.discuss.tick_hot.1': '« Choisis. »',
  'round.discuss.tick_hot.2': '« Décide-toi. »',

  'play.clochard.title': 'Clochard démasqué',
  'play.clochard.description': '{name}, devine le mot des Flics pour gagner.',
  'play.clochard.placeholder': 'Ta proposition',
  'play.clochard.submit': 'Valider',

  'role.flic': 'Flic',
  'role.infiltre': 'Infiltré',
  'role.clochard': 'Clochard',

  'home.online_join.eyebrow': 'En ligne',
  'home.online_join.label': 'Rejoindre',
  'home.online_join.description': "Tape le code reçu d'un ami.",

  'home.discord.eyebrow': 'Salon vocal · Activity',
  'home.discord.heading': 'Jouez avec votre salon',
  'home.discord.tagline': 'Tout le monde en vocal, un seul dossier.',
  'home.discord.lede': 'Tout le monde dans ce salon vocal rejoint le même dossier.',
  'home.discord.lede_named': 'Salut {name} — rassemble le salon vocal sur un même dossier.',
  'home.discord.start_activity': "Entrer dans la salle d'Activity",
  'home.discord.start_busy': 'Ouverture du dossier…',
  'home.discord.join_with_code': 'Rejoindre une autre salle avec un code',
  'home.discord.no_instance': "Activity Discord introuvable — relance l'Activity.",
  'home.discord.sdk_failed': "Le SDK Discord n'a pas pu démarrer. Réessaye.",
  'home.discord.sdk_retry': 'Réessayer',
  'home.discord.solo_label': 'Jouer sur cet appareil',
  'home.online.unavailable': 'Mode en ligne indisponible — serveur injoignable.',

  'online.create.eyebrow': 'Nouveau dossier',
  'online.create.heading': 'Créer une partie',
  'online.create.hint': 'Choisis un nom. Un code à partager sera généré.',
  'online.create.name_placeholder': 'Ton nom',
  'online.create.submit': 'Créer la partie',
  'online.create.creating': 'Création…',

  'online.join.eyebrow': 'Salle de briefing',
  'online.join.heading': 'Rejoindre une partie',
  'online.join.hint': 'Entre le code partagé par ton ami.',
  'online.join.name_placeholder': 'Ton nom',
  'online.join.code_placeholder': 'CODE',
  'online.join.submit': 'Rejoindre',
  'online.join.joining': 'Connexion…',

  'online.lobby.players': 'Joueurs',
  'online.lobby.briefing_room': 'Salle de briefing',
  'online.lobby.host_badge': 'Hôte',
  'online.lobby.you_badge': 'toi',
  'online.lobby.reconnecting_badge': 'reconnexion',
  'online.lobby.offline_badge': 'déconnecté',
  'online.toast.room_not_found': 'Salle introuvable',
  'online.toast.room_full': 'Salle pleine',
  'online.toast.kicked_after_grace': 'Tu as été déconnecté trop longtemps',
  'online.toast.unauthorized': 'Session expirée',
  'online.toast.presence_online': '{name} est reconnecté',
  'online.toast.presence_reconnecting': '{name} se reconnecte',
  'online.toast.presence_offline': '{name} est déconnecté',
  'online.toast.server_error.actor_mismatch': 'Cette action ne vient pas de ta session',
  'online.toast.server_error.unknown_player': 'Joueur introuvable dans la salle',
  'online.toast.server_error.name_required': 'Le nom ne peut pas être vide',
  'online.toast.server_error.invalid_message': 'Requête invalide',
  'online.toast.server_error.unauthorized': 'Non autorisé',
  'online.toast.server_error.only_host': 'Seul l’hôte peut faire ça',
  'online.toast.server_error.wrong_phase': 'Action trop tardive — la manche a avancé',
  'online.toast.server_error.invalid_target': 'Cible invalide',
  'online.toast.server_error.not_your_guess': 'Ce n’est pas à toi de deviner',
  'online.toast.server_error.not_a_member': 'Tu n’es pas dans cette salle',
  'online.toast.server_error.not_enough_players': 'Il faut plus de joueurs',
  'online.toast.server_error.too_many_players': 'Trop de joueurs',
  'online.toast.server_error.room_already_exists': 'Salle déjà existante',
  'online.toast.server_error.no_session': 'Session expirée — reconnexion',
  'online.toast.server_error.create_via_rest': 'Crée la salle depuis l’accueil',
  'online.toast.server_error.system_only_message': 'Message système bloqué',
  'online.toast.server_error.internal': 'Erreur serveur inattendue',
  'online.toast.server_error.generic': 'Erreur serveur : {message}',
  'online.lobby.waiting_host': "En attente de l'hôte…",
  'online.lobby.start_game': 'Lancer la partie',
  'online.lobby.need_more_players': 'Il faut au moins 3 joueurs',

  'online.room.code_label': 'Code de la salle',
  'online.room.code_hide': 'Masquer le code',
  'online.room.code_show': 'Afficher le code',
  'online.room.copy': 'Copier',
  'online.room.copied': 'Copié !',

  'online.banner.connecting': 'Reconnexion…',
  'online.banner.error': 'Connexion perdue. Nouvelle tentative.',

  'online.reveal.acknowledge': "C'est noté",
  'online.reveal.waiting.eyebrow': 'PHASE 01 · BRIEFING',
  'online.reveal.waiting.title': 'Briefing en cours',
  'online.reveal.waiting.descriptor': '— en attente de {pending} agent(s)',
  'online.reveal.waiting.center_label': 'prêts',
  'online.discuss.host_open_vote_button': 'Prêts à voter',
  'online.discuss.waiting_host': "En attente que l'hôte ouvre le vote…",
  'online.discuss.timer_label': 'Vote dans {time}',
  'online.discuss.timer_expired': 'Ouverture du vote…',
  'online.discuss.timer_eyebrow': 'Vote dans',
  'online.vote.spectating': 'Tu es éliminé. Tu regardes le tour.',
  'online.vote.waiting.eyebrow': 'PHASE 03 · VOTE',
  'online.vote.waiting.title': 'Dépouillement',
  'online.vote.waiting.descriptor': '— {pending} bulletin(s) en attente',
  'online.vote.waiting.center_label': 'votés',
  'online.clochard.spectating': '{name} tente le tout pour le tout.',
  'online.round.waiting_host': "En attente de l'hôte…",
  'online.spectator.heading': 'Spectateur',
  'online.spectator.eyebrow': 'HORS-JEU · TOUJOURS EN COULISSES',
  'online.spectator.eliminated': 'Tu es éliminé — tu regardes le tour.',
  'online.spectator.finished': 'Partie terminée.',
  'online.spectator.flic_word': 'Mot des Flics',
  'online.spectator.infiltre_word': 'Mot des Infiltrés',
  'online.spectator.phase_label': 'Phase : {phase}',
  'online.host_changed.banner': '{name} est désormais hôte.',
  'online.host_changed.you_banner': 'Tu es désormais hôte.',

  'platform.error.discord_unavailable': 'Les fonctions Discord ne sont pas disponibles ici.',
  'platform.error.tauri_unavailable': 'Les fonctions desktop ne sont pas disponibles ici.',
  'platform.error.capacitor_unavailable': 'Les fonctions mobiles ne sont pas disponibles ici.',
  'platform.error.identity_failed': 'Connexion impossible. Réessaie.',
  'platform.banner.platform_label': 'Exécution sur {platform}',
  'platform.discord.connecting': 'Connexion à Discord…',
  'platform.discord.authorizing': 'Autorisation Discord…',
  'platform.tauri.connecting': 'Chargement de la session…',
  'platform.capacitor.connecting': 'Chargement de la session…',
  'a11y.privacy_gate.aria_label': 'Maintiens pour révéler — passe à {name}',
  'a11y.vote_board.candidate_aria_label': 'Voter pour {name}',
  'a11y.audio.mute_label': 'Couper les effets sonores',
  'a11y.audio.unmute_label': 'Activer les effets sonores',
  'a11y.audio.volume_label': 'Volume des effets',

  'nav.brand': "L'Infiltré",
  'nav.back': 'Retour',
  'nav.home_label': "Retour à l'accueil",
  'nav.settings_label': 'Ouvrir les paramètres',

  'settings.title': 'Paramètres',
  'settings.close': 'Fermer',
  'settings.section.language': 'Langue',
  'settings.language.subtitle': "choisis la langue de l'interface",
  'settings.section.theme': 'Thème',
  'settings.theme.noir': 'Noir',
  'settings.theme.party': 'Fête',
  'settings.section.layout': 'Mise en page',
  'settings.layout.auto': 'Auto',
  'settings.layout.mobile': 'Mobile',
  'settings.layout.desktop': 'Bureau',
  'settings.section.audio': 'Audio',
  'settings.audio.mute': 'Couper les effets sonores',
  'settings.audio.volume': 'Volume',

  'mode.select.heading': 'Choisis un mode',
  'mode.select.hint': 'Choisis comment jouer. Tu pourras changer depuis les paramètres.',
  'mode.select.coming_soon': 'Bientôt',
  'mode.infiltre_classic.name': "L'Infiltré",
  'mode.infiltre_classic.tagline': 'Flics contre Infiltrés. Démasque qui ne colle pas.',
  'mode.team_deathmatch.name': 'Match par équipes',
  'mode.team_deathmatch.tagline': 'Deux équipes, deux mots. Trouve tes alliés.',

  'briefing.phase_00': 'Phase 00 · Mise en place',
  'briefing.title': 'Briefing',
  'briefing.subtitle': 'règle la table avant de distribuer',
  'briefing.mode.label': 'Mode — choisis-en un',
  'briefing.mode.classic': '1 Infiltré · standard',
  'briefing.mode.duo': '2 Infiltrés · 6+ joueurs',
  'briefing.mode.trio': '3 Infiltrés · 9+ joueurs',
  'briefing.mode.clochard': '+ Clochard · 5+ joueurs',
  'briefing.timer.label': 'Discussion · secondes',
  'briefing.clochard.label': 'Inclure un Clochard',
  'briefing.clochard.hint': '(joueur sans mot)',
  'briefing.footer.ready': 'prêt — {count} suspects',
  'briefing.footer.need_more': 'encore {count} joueur(s)',
  'briefing.footer.deal': 'Distribuer',
  'briefing.tape.briefing_room': 'Briefing room',
  'briefing.tape.how_to_play_l1': 'comment',
  'briefing.tape.how_to_play_l2': 'jouer ?',

  'round.distribution.phase_eyebrow': 'PHASE 01 · DISTRIBUTION',
  'round.distribution.title': 'Distribution',
  'round.distribution.descriptor': '— {step} sur {total}',
  'round.distribution.tour': 'TOUR',
  'round.distribution.no_peeking_tape': 'NE PAS REGARDER',
  'round.dossier.phase_eyebrow': 'PHASE 01 · DOSSIER PERSONNEL',
  'round.dossier.title': 'Dossier',
  'round.dossier.descriptor': '— maintiens le doigt pour lire',
  'round.dossier.field_name': 'NOM',
  'round.dossier.field_role': 'RÔLE',
  'round.dossier.field_word': 'MOT-CLÉ',
  'round.dossier.release_to_hide': '— relâche pour cacher',
  'round.dossier.close_cta': 'FERMER LE DOSSIER',
  'round.speaking.phase_eyebrow': 'PHASE 02 · TOUR DE PAROLE',
  'round.speaking.descriptor': '— un mot, à voix haute, dans l’ordre',
  'round.discuss.phase_eyebrow': 'PHASE 03 · DÉBAT OUVERT',
  'round.discuss.title': 'Débat',
  'round.discuss.descriptor': '— qui ment ? discutez à voix haute.',
  'round.discuss.timer_eyebrow': 'CHRONOMÈTRE · TEMPS RESTANT',
  'round.discuss.timer_calm_sub': '— prends ton temps',
  'round.discuss.timer_danger_sub': '— le temps presse',
  'round.discuss.suspects_pill': '{count} suspects en piste',
  'round.vote.phase_eyebrow': 'PHASE 04 · VOTE À LA TABLE',
  'round.vote.title': 'Vote',
  'round.vote.descriptor': '— votez à voix haute, marque l’éliminé',
  'round.verdict.phase_eyebrow': 'PHASE 05 · VERDICT',
  'round.verdict.descriptor': '— le suspect tombe',
  'round.verdict.role_revealed': 'RÔLE RÉVÉLÉ',
  'round.verdict.role_tagline.flic': 'mot vrai · innocent',
  'round.verdict.role_tagline.infiltre': 'mot truqué · coupable',
  'round.verdict.role_tagline.clochard': 'sans mot · joker',
  'round.verdict.stamp': 'ÉLIMINÉ',
  'round.verdict.no_elimination.title': 'Aucune élimination',
  'round.verdict.no_elimination.stamp': 'DOSSIER REPORTÉ',
  'round.verdict.no_elimination.descriptor': '— les voix se partagent, la partie continue',
  'round.verdict.no_elimination.still_in': 'Encore en lice',
};
